const client = require('@sanity/client')({
    projectId: 'zlybple6',
    dataset: 'production',
    useCdn: true,
});

export const sanityConfig = {
    projectId: 'zlybple6',
    dataset: 'production',
};

export default client;
